import { auth } from "../firebase";

const API_BASE =
  process.env.REACT_APP_API_URL ||
  "https://asia-south1-resmenu-c1b90.cloudfunctions.net/api";

/** Firebase ID token for the logged-in backoffice user. */
export async function getAuthHeaders(extra = {}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("Not signed in");
  }
  const idToken = await user.getIdToken();
  return {
    Authorization: `Bearer ${idToken}`,
    ...extra,
  };
}

export async function apiFetch(path, options = {}) {
  const headers = await getAuthHeaders({
    "Content-Type": "application/json",
    ...(options.headers || {}),
  });
  return fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });
}

export { API_BASE };
